import { useEffect, useState } from "react";
import API from "./API";
import { AdminGetYearData } from '../../backend/src/api/dto'
import { Link, useNavigate, useParams } from "react-router";
import { months } from './global'
import DisplayTimeReportState from "./components/DisplayTimeReportState";
import dayjs from "dayjs";


function ReportingPerson({setWhat}: {setWhat: Function}) {

    const params = useParams();
    let navigate = useNavigate();

    const [loading, setLoading] = useState<boolean>(false)
    const [data, setData] = useState<AdminGetYearData>({ users: [], reports: [] })


    useEffect(() => {
        // if (!params.year) {
        //     const year = dayjs().year()
        //     navigate('/dashboard/reporting/person/' + year, { replace: true })
        // } else {
            setLoading(true)
            getData()
        //}
        
        setWhat('person')
    }, [params.year])


    const getData = () => {
        return API.getYearData(params.year).then((data: AdminGetYearData) => {
            setData(data)
            setLoading(false)
        })
    }


    const getMonthData = (personId: number, month: number) => {
        const found = data.reports.find((report) => {
            return report.personId === personId && report.month === month
        })
        if (found) {
            return found.status
        }
        return null
    }

    return (

        <table className="table table-bordered">
            <thead>
                <tr>
                    <th className="text-center">Meno/Mesiac</th>
                    {
                        months.map((monthName, index) => {
                            return (
                                <th className="text-center  " >{monthName}</th>
                            )

                        })
                    }
                </tr>
            </thead>
            <tbody>
                {
                    loading ?
                        <tr>
                            <td colSpan={13}>Nahrávam</td>
                        </tr>
                        :
                        data.users.map((user) => {
                            return (
                                <tr>
                                    <td>{user.name} {user.surname}</td>
                                    {
                                        months.map((monthName, index) => {
                                            return (
                                                <td className="text-center" style={{ width: '100px' }}><Link to={"/dashboard/reporting/" + params.year + "/person/" + (index + 1) + "/" + user.personId}><DisplayTimeReportState state={getMonthData(user.personId, index + 1)} /></Link></td>
                                            )

                                        })
                                    }
                                </tr>
                            )
                        })
                }
            </tbody>
        </table>

    )
}

export default ReportingPerson;

